import React, {useEffect, useMemo, useState} from 'react';
import {VStack, HStack, Divider, ScrollView, Box} from 'native-base';
import { useDispatch, useSelector } from 'react-redux';
import AppText from '../../../../../../common/AppText';
import { GlobalStyleAttributes } from '../../../../../../../styles/GlobalStyles';
import { t } from '../../../../../../../services/i18n';
import CustomButtonV2 from '../../../../../../common/CustomButtonV2';
import { GlobalConsts } from '../../../../../../../styles/GlobalConsts';
import { getCalendarSync } from "../../../../../../../redux/boxSlice";
import {Colors} from "../../../../../../../styles/Colors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light, solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import ConfirmModal from "../../../../../../common/ConfirmModal";
import {isMobile} from "../../../../../../../services/Helpers";
import InfoTooltip from "../../../../../../common/InfoTooltip";
import { SEND_SYNC_INVITE } from '../../../../../../../Configs/SettingsValueModalOptions';
import { openModal } from '../../../../../../../redux/modalManagerSlice';
import { SETTINGS_VALUE_MODAL } from '../../../../../../../redux/modalManagerSlice';
import SyncRow from './SyncRow';
import ConnectButton from './components/ConnectButton';
import usePermissions from "../../../../../../../services/Permissions";
import useGoogleCalendarSync from '../../../../../../../Hooks/useGoogleCalendarSync';
import {Skeleton} from "antd";
const GoogleCalendarSyncMultiStaff = (props) => {
    const { values, setFieldValue, errors } = props;
    const dispatch = useDispatch();
    const { has } = usePermissions();
    const calendarSync = useSelector((state) => state.box.box.calendarSync);
    const user = useSelector(state => state.user.user);
    const [showActionMessage, setShowActionMessage] = useState(true);
    const [loader, setLoader] = useState(true);

    const {
        confirm,
        disableConnection,
        disableReason,
        connectToGoogleCalendar,
        showConfirmDeleteSync,
        setConfirm
    } = useGoogleCalendarSync({
        onConnectSuccess: () => {
            dispatch(getCalendarSync());
        },
        onDisconnectSuccess: () => {
            dispatch(getCalendarSync());
        }
    });

    const loggedUserSyncConnection = useMemo(() => calendarSync?.find(item => item.users_boxes_id === user.id), [calendarSync, user.id]);
    const otherUsersSyncConnections = useMemo(() => calendarSync?.filter(item => item.users_boxes_id !== user.id) || [], [calendarSync, user.id]);

    useEffect(() => {
        dispatch(getCalendarSync());
    }, []);

    useEffect(() => {
        if (calendarSync !== undefined) {
            setLoader(false);
        }
    }, [calendarSync]);

    useEffect(() => {
        if (calendarSync?.status === 'active') {
            setShowActionMessage(true);
            const timer = setTimeout(() => {
                setShowActionMessage(false);
            }, 5 * 60 * 1000);

            return () => clearTimeout(timer);
        }
    }, [calendarSync?.status]);

    const sendSyncInvite = () => {
        dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: SEND_SYNC_INVITE}}));
    };

    return (loader ? <VStack>
                <Skeleton active paragraph={{rows: 1, width: '100%'}} title={false}/>
                <Skeleton active paragraph={{rows: 1, width: '100%'}} title={false}/>
                <Skeleton active paragraph={{rows: 1, width: '100%'}} title={false}/>
            </VStack> :
        <VStack space={'1.5rem'}>
            <VStack space={'1rem'}>
                <AppText fontSize={isMobile ? GlobalStyleAttributes.fonts.mainHeader : GlobalStyleAttributes.fonts.standard16} boldFont>{t('googleCalendarSync')}</AppText>
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>
                    {calendarSync?.status === 'active' ? t('googleCalendarSyncTxtConnectedMultiStaff') : t('googleCalendarSyncTxtMultiStaff')}
                    {' '}
                    <span onClick={() => window.open('https://placeholder-url.com', '_blank')}
                    style={{color: Colors.newDesign.mainBlue, cursor: 'pointer'}}>
                        {t('learn-more')}
                    </span>
                </AppText>
                {calendarSync?.length > 0 ?
                    <VStack space={'10px'}>
                        <HStack>
                            <AppText fontSize={isMobile ? GlobalStyleAttributes.fonts.mainHeader : GlobalStyleAttributes.fonts.standard16} boldFont>{t('syncedUsers')}</AppText>
                            <InfoTooltip title={t('syncUsers-info')}/>
                        </HStack>
                        <ScrollView>
                            <VStack space={'0.5rem'}>
                                <HStack justifyContent={'space-between'} width={'100%'}>
                                    <HStack width={'30%'}><AppText mediumFont>{t('sync-staff-name')}</AppText></HStack>
                                    {!isMobile && <>
                                        <HStack width={'25%'}><AppText mediumFont>{t('sync-status')}</AppText></HStack>
                                        <HStack width={'30%'}><AppText mediumFont>{t('sync-type')}</AppText></HStack>
                                    </>}
                                    <HStack width={'15%'} justifyContent={'center'}><AppText mediumFont>{t('sync-actions')}</AppText></HStack>
                                </HStack>
                                <Divider orientation="horizontal" h={'1px'} w={'100%'} bg={Colors.borderColor}/>
                            </VStack>
                            <Box overflow={'auto'}>
                                {loggedUserSyncConnection ? <SyncRow key={loggedUserSyncConnection.id} item={loggedUserSyncConnection} loggedUser={true} onDisconnect={showConfirmDeleteSync}/> : <SyncRow item={{full_name: user.full_name}} loggedUser={true} onConnect={connectToGoogleCalendar} disableReason={disableReason}/>}
                                {otherUsersSyncConnections.map(item => <SyncRow key={item.id} item={item} onDisconnect={showConfirmDeleteSync}/>)}
                            </Box>
                        </ScrollView>
                    </VStack>
                    :
                    <ConnectButton
                        onConnect={connectToGoogleCalendar}
                        disabled={disableConnection}
                        disableReason={disableReason}
                    />
                }
                {calendarSync && calendarSync?.status === 'disconnected' && <HStack space={'0.5rem'} alignItems={'center'}>
                    <FontAwesomeIcon icon={solid('triangle-exclamation')}/>
                    <AppText>{t('disconnect-due-to', {error: t(calendarSync.disconnect_reason)})}</AppText>
                </HStack>}
                {calendarSync && calendarSync?.status === 'active' && showActionMessage && <AppText color={Colors.newDesign.darkGrey}>{t('action-may-take-a-while')}</AppText>}
                {has('calendarInvite') &&
                    <CustomButtonV2 onClick={sendSyncInvite}
                                    iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                                    override={({color}) => (
                                        <HStack space={'0.5rem'} alignItems={'center'}>
                                            <FontAwesomeIcon color={color} icon={light('paper-plane')} fontSize={GlobalConsts.iconSize.XS}/>
                                            <AppText color={color}>{t('send-sync-invite')}</AppText>
                                        </HStack>)}
                />}
            </VStack>
            {confirm && <ConfirmModal
                isOpen={confirm}
                {...(confirm ? confirm : {})}
                header={confirm?.header}
                subheader={confirm?.subheader}
                confirmText={confirm?.confirmText}
                cancelText={confirm?.cancelText}
                confirmLoading={confirm?.confirmLoading}
                onConfirm={confirm?.onConfirm}
                onCancel={() => setConfirm(null)}
                onClose={() => setConfirm(null)} />}
    </VStack>
    )
}

export default GoogleCalendarSyncMultiStaff;